import React from 'react';
import { ShieldCheckIcon, StarIcon, CheckCircleIcon, LockIcon } from 'lucide-react';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { MetaPixel } from '../components/MetaPixel';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/s5KS3b6L8LzyJFRNTPLuNK/ChatGPT_Image_25_feb_2026,_09_29_42_p.m..png';
const BONO1_IMAGE = 'https://cdn.magicpatterns.com/uploads/bT5yUKPvnC336exKhFwS7u/ChatGPT_Image_23_feb_2026,_08_37_42_p.m..png';
const BONO2_IMAGE = 'https://cdn.magicpatterns.com/uploads/7uipUcGVzbxJXsBPHoSkkP/ChatGPT_Image_23_feb_2026,_09_16_54_p.m..png';
const BONO3_IMAGE = 'https://cdn.magicpatterns.com/uploads/1DSwn6e2AszsabPg7Qonvk/ChatGPT_Image_23_feb_2026,_09_21_24_p.m..png';
const PURCHASE_URL = 'https://checkout.impulsodigitalx.shop/cart/45776967565473:1';
function CtaButton({
  href,
  children,
  className = ''
}: {
  href: string;
  children: React.ReactNode;
  className?: string;
}) {
  return <a href="#comprar" className={`inline-block text-center font-black text-white uppercase tracking-wide rounded-full shadow-lg transition-transform hover:scale-105 active:scale-95 ${className}`} style={{
    fontFamily: 'Lato, sans-serif'
  }} data-id="element-12">
      {children}
    </a>;
}
function StarRating({
  count = 5
}: {
  count?: number;
}) {
  return <div className="flex gap-0.5" data-id="element-13">
      {Array.from({
      length: count
    }).map((_, i) => <StarIcon key={i} size={16} className="fill-yellow-400 text-yellow-400" data-id="element-14" />)}
    </div>;
}
export function SalesPage() {
  return <div className="w-full min-h-screen bg-white" style={{
    fontFamily: 'Lato, sans-serif'
  }} data-id="element-15">
      <SocialProofPopup data-id="element-16" />
      <MetaPixel data-id="element-17" />

      {/* TOP URGENCY BAR */}
      <div className="w-full bg-black text-white text-center py-3 px-4" data-id="element-18">
        <p className="text-sm md:text-base font-black tracking-wide animate-pulse" data-id="element-19">
          ⚡ PRECIO LANZAMIENTO — Solo por hoy:{' '}
          <span className="text-yellow-400" data-id="element-20">$19.990 ARS</span> ⚡
        </p>
      </div>

      {/* HERO SECTION */}
      <section className="w-full bg-white py-12 px-4" data-id="element-21">
        <div className="max-w-3xl mx-auto text-center" data-id="element-22">
          <div className="inline-block bg-red-100 text-red-700 font-black text-xs uppercase tracking-widest px-4 py-2 rounded-full mb-6" data-id="element-23">
            ⚠️ Atención — Leer antes de continuar
          </div>
          <h1 className="text-3xl md:text-5xl font-black text-gray-900 leading-tight mb-6" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-24">
            Si estás embarazada, esto puede cambiar completamente cómo vas a
            vivir los próximos meses.
          </h1>

          {/* Product Image */}
          <a href="#comprar" className="block mx-auto mb-8 cursor-pointer" data-id="element-25">
            <img src={PRODUCT_IMAGE} alt="Gestando en Calma - Guía completa de 5 tomos" className="mx-auto w-full max-w-sm md:max-w-md drop-shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-26" />
          </a>

          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed mb-8 max-w-2xl mx-auto" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-27">
            Porque la diferencia entre un embarazo con miedo… y un embarazo con
            calma… no es suerte.
            <br data-id="element-28" />
            <span className="font-bold text-pink-600" data-id="element-29">Es preparación.</span>
          </p>

          <CtaButton href="#comprar" className="bg-gradient-to-r from-pink-500 to-pink-600 text-lg md:text-xl px-8 md:px-12 py-5 md:py-6 shadow-pink-300 shadow-xl" data-id="element-30">
            🌸 QUIERO VIVIR MI EMBARAZO CON CALMA →
          </CtaButton>

          <p className="text-sm text-gray-500 mt-4" data-id="element-31">
            🔒 Acceso inmediato · Garantía 7 días sin preguntas
          </p>
        </div>
      </section>

      {/* PAIN SECTION */}
      <section className="w-full bg-pink-50 py-14 px-4" data-id="element-32">
        <div className="max-w-2xl mx-auto" data-id="element-33">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 text-center mb-8" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-34">
            Si hoy estás…
          </h2>
          <div className="space-y-4 mb-10" data-id="element-35">
            <div className="flex items-start gap-3 bg-white rounded-xl p-4 shadow-sm border border-pink-100" data-id="element-36">
              <span className="text-2xl" data-id="element-37">😰</span>
              <p className="text-gray-800 font-semibold text-lg" data-id="element-38">
                Googleando cada síntoma
              </p>
            </div>
            <div className="flex items-start gap-3 bg-white rounded-xl p-4 shadow-sm border border-pink-100" data-id="element-39">
              <span className="text-2xl" data-id="element-40">😟</span>
              <p className="text-gray-800 font-semibold text-lg" data-id="element-41">
                Asustándote con historias ajenas
              </p>
            </div>
            <div className="flex items-start gap-3 bg-white rounded-xl p-4 shadow-sm border border-pink-100" data-id="element-42">
              <span className="text-2xl" data-id="element-43">🤔</span>
              <p className="text-gray-800 font-semibold text-lg" data-id="element-44">
                Dudando si lo que sentís es normal
              </p>
            </div>
            <div className="flex items-start gap-3 bg-white rounded-xl p-4 shadow-sm border border-pink-100" data-id="element-45">
              <span className="text-2xl" data-id="element-46">😨</span>
              <p className="text-gray-800 font-semibold text-lg" data-id="element-47">
                Con miedo al parto
              </p>
            </div>
            <div className="flex items-start gap-3 bg-white rounded-xl p-4 shadow-sm border border-pink-100" data-id="element-48">
              <span className="text-2xl" data-id="element-49">💭</span>
              <p className="text-gray-800 font-semibold text-lg" data-id="element-50">
                Preguntándote en silencio "¿y si algo sale mal?"
              </p>
            </div>
          </div>
          <div className="bg-white border-l-4 border-pink-500 rounded-xl p-6 shadow-md text-center" data-id="element-51">
            <p className="text-xl md:text-2xl font-black text-gray-900 leading-relaxed" style={{
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-52">
              No estás exagerando.
            </p>
            <p className="text-lg text-gray-700 mt-2" data-id="element-53">
              Estás sola frente a demasiada información.
              <br data-id="element-54" />
              <span className="font-bold text-pink-600" data-id="element-55">
                Y eso genera ansiedad.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* TRUTH SECTION */}
      <section className="w-full bg-white py-14 px-4" data-id="element-56">
        <div className="max-w-2xl mx-auto text-center" data-id="element-57">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-6" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-58">
            La verdad incómoda
          </h2>
          <p className="text-xl md:text-2xl text-gray-800 font-bold mb-8 leading-relaxed" data-id="element-59">
            Tu embarazo no debería vivirse con miedo constante.
          </p>
          <p className="text-lg text-gray-600 mb-8" data-id="element-60">Pero nadie te enseñó:</p>
          <div className="text-left space-y-3 max-w-lg mx-auto" data-id="element-61">
            <div className="flex items-center gap-3" data-id="element-62">
              <CheckCircleIcon className="text-pink-500 flex-shrink-0" size={22} data-id="element-63" />
              <p className="text-gray-800 font-semibold" data-id="element-64">
                Qué es realmente normal
              </p>
            </div>
            <div className="flex items-center gap-3" data-id="element-65">
              <CheckCircleIcon className="text-pink-500 flex-shrink-0" size={22} data-id="element-66" />
              <p className="text-gray-800 font-semibold" data-id="element-67">
                Cuándo preocuparte y cuándo no
              </p>
            </div>
            <div className="flex items-center gap-3" data-id="element-68">
              <CheckCircleIcon className="text-pink-500 flex-shrink-0" size={22} data-id="element-69" />
              <p className="text-gray-800 font-semibold" data-id="element-70">
                Cómo prepararte mentalmente para el parto
              </p>
            </div>
            <div className="flex items-center gap-3" data-id="element-71">
              <CheckCircleIcon className="text-pink-500 flex-shrink-0" size={22} data-id="element-72" />
              <p className="text-gray-800 font-semibold" data-id="element-73">
                Cómo conectar con tu bebé desde ahora
              </p>
            </div>
            <div className="flex items-center gap-3" data-id="element-74">
              <CheckCircleIcon className="text-pink-500 flex-shrink-0" size={22} data-id="element-75" />
              <p className="text-gray-800 font-semibold" data-id="element-76">
                Cómo sentirte segura en lugar de confundida
              </p>
            </div>
          </div>
          <p className="text-lg text-gray-600 mt-8 italic" data-id="element-77">
            Y cuando no hay claridad… aparece el miedo.
          </p>
        </div>
      </section>

      {/* PRODUCT SECTION */}
      <section className="w-full bg-white py-14 px-4 border-t border-pink-100" data-id="element-78">
        <div className="max-w-3xl mx-auto text-center" data-id="element-79">
          <div className="inline-block bg-pink-100 text-pink-700 font-black text-sm uppercase tracking-widest px-5 py-2 rounded-full mb-4" data-id="element-80">
            La solución
          </div>
          <h2 className="text-4xl md:text-5xl font-black mb-4" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#6b21a8'
        }} data-id="element-81">
            🌸 Gestando en Calma
          </h2>
          <p className="text-xl text-gray-700 mb-6 leading-relaxed max-w-2xl mx-auto" data-id="element-82">
            El sistema completo creado exclusivamente para madres primerizas que
            no quieren atravesar su embarazo desde la incertidumbre.
          </p>
          <div className="bg-purple-50 border border-purple-200 rounded-2xl p-6 mb-8 text-left max-w-xl mx-auto" data-id="element-83">
            <p className="text-gray-700 font-semibold mb-2" data-id="element-84">
              No es un ebook suelto. No es información reciclada de internet.
            </p>
            <p className="text-gray-700" data-id="element-85">
              Es una{' '}
              <span className="font-black text-purple-700" data-id="element-86">
                guía estructurada paso a paso
              </span>{' '}
              para que recuperes control y tranquilidad.
            </p>
          </div>
          <h3 className="text-2xl font-black text-gray-900 mb-5" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-87">
            Incluye:
          </h3>
          <div className="space-y-3 max-w-lg mx-auto text-left mb-8" data-id="element-88">
            <div className="flex items-center gap-3 bg-white border border-pink-200 rounded-xl p-4 shadow-sm" data-id="element-89">
              <CheckCircleIcon className="text-purple-600 flex-shrink-0" size={22} data-id="element-90" />
              <p className="text-gray-800 font-bold" data-id="element-91">
                5 Tomos completos (embarazo, cuerpo, parto, transición)
              </p>
            </div>
            <div className="flex items-center gap-3 bg-white border border-pink-200 rounded-xl p-4 shadow-sm" data-id="element-92">
              <CheckCircleIcon className="text-purple-600 flex-shrink-0" size={22} data-id="element-93" />
              <p className="text-gray-800 font-bold" data-id="element-94">
                Guía de señales de alerta
              </p>
            </div>
            <div className="flex items-center gap-3 bg-white border border-pink-200 rounded-xl p-4 shadow-sm" data-id="element-95">
              <CheckCircleIcon className="text-purple-600 flex-shrink-0" size={22} data-id="element-96" />
              <p className="text-gray-800 font-bold" data-id="element-97">Nutrición consciente</p>
            </div>
            <div className="flex items-center gap-3 bg-white border border-pink-200 rounded-xl p-4 shadow-sm" data-id="element-98">
              <CheckCircleIcon className="text-purple-600 flex-shrink-0" size={22} data-id="element-99" />
              <p className="text-gray-800 font-bold" data-id="element-100">Meditaciones guiadas</p>
            </div>
          </div>
          <div className="bg-gradient-to-r from-pink-100 to-purple-100 rounded-2xl p-5 mb-8" data-id="element-101">
            <p className="text-xl font-black text-purple-800" style={{
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-102">
              Más de 250 páginas diseñadas para darte claridad real.
            </p>
          </div>
          <CtaButton href="#comprar" className="bg-gradient-to-r from-orange-500 to-pink-500 text-lg md:text-xl px-8 md:px-12 py-5 shadow-orange-300 shadow-xl" data-id="element-103">
            🌸 QUIERO ACCEDER AHORA →
          </CtaButton>
        </div>
      </section>

      {/* VISUALIZATION SECTION - DARK */}
      <section className="w-full bg-gray-950 py-16 px-4" data-id="element-104">
        <div className="max-w-2xl mx-auto text-center" data-id="element-105">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-10" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-106">
            Imaginá esto…
          </h2>
          <div className="space-y-5 mb-10 text-left" data-id="element-107">
            <div className="flex items-start gap-4" data-id="element-108">
              <span className="text-3xl" data-id="element-109">🌅</span>
              <p className="text-white text-lg font-semibold" data-id="element-110">
                Despertarte sin ansiedad.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-111">
              <span className="text-3xl" data-id="element-112">💡</span>
              <p className="text-white text-lg font-semibold" data-id="element-113">
                Sentir un síntoma y saber interpretarlo.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-114">
              <span className="text-3xl" data-id="element-115">🤱</span>
              <p className="text-white text-lg font-semibold" data-id="element-116">
                Pensar en el parto sin pánico.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-117">
              <span className="text-3xl" data-id="element-118">💪</span>
              <p className="text-white text-lg font-semibold" data-id="element-119">
                Sentirte preparada.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-120">
              <span className="text-3xl" data-id="element-121">✨</span>
              <p className="text-white text-lg font-semibold" data-id="element-122">
                Sentirte capaz.
              </p>
            </div>
          </div>
          <p className="text-3xl md:text-4xl font-black text-pink-400 mb-10" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-123">
            Eso cambia todo.
          </p>
          <CtaButton href="#comprar" className="bg-gradient-to-r from-pink-500 to-purple-600 text-lg md:text-xl px-8 md:px-12 py-5 shadow-pink-500 shadow-xl" data-id="element-124">
            ✨ SÍ, QUIERO ESTE CAMBIO →
          </CtaButton>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="w-full bg-white py-16 px-4" data-id="element-125">
        <div className="max-w-5xl mx-auto" data-id="element-126">
          <div className="text-center mb-12" data-id="element-127">
            <div className="inline-block bg-yellow-100 text-yellow-800 font-black text-sm uppercase tracking-widest px-5 py-2 rounded-full mb-4" data-id="element-128">
              🎁 Bonos exclusivos
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-gray-900" style={{
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-129">
              Además, hoy incluye <span className="text-pink-600" data-id="element-130">GRATIS:</span>
            </h2>
            <p className="text-lg text-gray-600 mt-3" data-id="element-131">
              Solo por el día de hoy — estos bonos son completamente gratuitos
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-132">
            {/* Bono 1 */}
            <div className="flex flex-col items-center text-center bg-pink-50 rounded-2xl p-6 border border-pink-100 shadow-md" data-id="element-133">
              <div className="relative mb-4 w-full" data-id="element-134">
                <a href="#comprar" className="block cursor-pointer" data-id="element-135">
                  <div className="w-full aspect-square bg-white rounded-xl overflow-hidden shadow-lg" data-id="element-136">
                    <img src={BONO1_IMAGE} alt="Bono 1 - Nutrición Consciente en el Embarazo" className="w-full h-full object-contain" data-id="element-137" />
                  </div>
                </a>
                <div className="absolute -top-3 -right-3 bg-green-500 text-white text-xs font-black px-3 py-1.5 rounded-full shadow-lg uppercase tracking-wide" data-id="element-138">
                  GRATIS HOY
                </div>
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-2" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-139">
                🥗 Nutrición Consciente
              </h3>
              <p className="text-gray-600 text-sm mb-3" data-id="element-140">
                Alimentá tu cuerpo y el de tu bebé con equilibrio y seguridad
                durante el embarazo.
              </p>
              <div className="flex items-center gap-2" data-id="element-141">
                <span className="text-gray-400 line-through text-sm" data-id="element-142">
                  $9.000 ARS
                </span>
                <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full" data-id="element-143">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bono 2 */}
            <div className="flex flex-col items-center text-center bg-pink-50 rounded-2xl p-6 border border-pink-100 shadow-md" data-id="element-144">
              <div className="relative mb-4 w-full" data-id="element-145">
                <a href="#comprar" className="block cursor-pointer" data-id="element-146">
                  <div className="w-full aspect-square bg-white rounded-xl overflow-hidden shadow-lg" data-id="element-147">
                    <img src={BONO2_IMAGE} alt="Bono 2 - Guía de Emergencias y Señales de Alerta" className="w-full h-full object-contain" data-id="element-148" />
                  </div>
                </a>
                <div className="absolute -top-3 -right-3 bg-green-500 text-white text-xs font-black px-3 py-1.5 rounded-full shadow-lg uppercase tracking-wide" data-id="element-149">
                  GRATIS HOY
                </div>
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-2" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-150">
                🚨 Guía de Emergencias
              </h3>
              <p className="text-gray-600 text-sm mb-3" data-id="element-151">
                Sabé cuándo actuar sin vivir con miedo. Señales de alerta claras
                y precisas.
              </p>
              <div className="flex items-center gap-2" data-id="element-152">
                <span className="text-gray-400 line-through text-sm" data-id="element-153">
                  $12.000 ARS
                </span>
                <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full" data-id="element-154">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bono 3 */}
            <div className="flex flex-col items-center text-center bg-pink-50 rounded-2xl p-6 border border-pink-100 shadow-md" data-id="element-155">
              <div className="relative mb-4 w-full" data-id="element-156">
                <a href="#comprar" className="block cursor-pointer" data-id="element-157">
                  <div className="w-full aspect-square bg-white rounded-xl overflow-hidden shadow-lg" data-id="element-158">
                    <img src={BONO3_IMAGE} alt="Bono 3 - Meditaciones Guiadas para Embarazadas" className="w-full h-full object-contain" data-id="element-159" />
                  </div>
                </a>
                <div className="absolute -top-3 -right-3 bg-green-500 text-white text-xs font-black px-3 py-1.5 rounded-full shadow-lg uppercase tracking-wide" data-id="element-160">
                  GRATIS HOY
                </div>
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-2" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-161">
                🧘 Meditaciones Guiadas
              </h3>
              <p className="text-gray-600 text-sm mb-3" data-id="element-162">
                Calma, conexión y confianza durante la gestación. Preparación
                mental para el parto.
              </p>
              <div className="flex items-center gap-2" data-id="element-163">
                <span className="text-gray-400 line-through text-sm" data-id="element-164">
                  $15.000 ARS
                </span>
                <span className="bg-green-100 text-green-700 font-black text-sm px-3 py-1 rounded-full" data-id="element-165">
                  GRATIS
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section id="comprar" className="w-full bg-gray-950 py-16 px-4" data-id="element-166">
        <div className="max-w-2xl mx-auto text-center" data-id="element-167">
          <div className="inline-block bg-yellow-400 text-black font-black text-sm uppercase tracking-widest px-5 py-2 rounded-full mb-6" data-id="element-168">
            🔥 Oferta especial — Solo por hoy
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-8" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-169">
            Todo lo que recibís hoy:
          </h2>

          {/* Value Stack */}
          <div className="bg-gray-900 rounded-2xl p-6 mb-8 text-left space-y-3" data-id="element-170">
            <div className="flex justify-between items-center border-b border-gray-700 pb-3" data-id="element-171">
              <span className="text-white font-semibold" data-id="element-172">
                📚 Gestando en Calma (5 Tomos)
              </span>
              <span className="text-gray-400 line-through text-sm" data-id="element-173">
                $89.000
              </span>
            </div>
            <div className="flex justify-between items-center border-b border-gray-700 pb-3" data-id="element-174">
              <span className="text-white font-semibold" data-id="element-175">
                🥗 Nutrición Consciente
              </span>
              <span className="text-green-400 font-bold text-sm" data-id="element-176">
                GRATIS ($9.000)
              </span>
            </div>
            <div className="flex justify-between items-center border-b border-gray-700 pb-3" data-id="element-177">
              <span className="text-white font-semibold" data-id="element-178">
                🚨 Guía de Emergencias
              </span>
              <span className="text-green-400 font-bold text-sm" data-id="element-179">
                GRATIS ($12.000)
              </span>
            </div>
            <div className="flex justify-between items-center border-b border-gray-700 pb-3" data-id="element-180">
              <span className="text-white font-semibold" data-id="element-181">
                🧘 Meditaciones Guiadas
              </span>
              <span className="text-green-400 font-bold text-sm" data-id="element-182">
                GRATIS ($15.000)
              </span>
            </div>
            <div className="flex justify-between items-center pt-2" data-id="element-183">
              <span className="text-white font-black text-lg" data-id="element-184">Valor total</span>
              <span className="text-gray-400 line-through text-lg font-bold" data-id="element-185">
                $125.000 ARS
              </span>
            </div>
          </div>

          <div className="mb-4" data-id="element-186">
            <p className="text-gray-400 text-lg line-through mb-1" data-id="element-187">
              💰 Precio regular: $89.000 ARS
            </p>
          </div>
          <div className="bg-gradient-to-r from-pink-500 to-purple-600 rounded-2xl p-6 mb-8" data-id="element-188">
            <p className="text-white text-lg font-bold mb-1" data-id="element-189">
              🔥 Hoy podés acceder por:
            </p>
            <p className="text-5xl md:text-6xl font-black text-yellow-300" style={{
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-190">
              $19.990 ARS
            </p>
            <p className="text-pink-100 text-sm mt-2" data-id="element-191">
              Acceso inmediato · Descarga digital
            </p>
          </div>

          <a href={PURCHASE_URL} className="block w-full text-center font-black text-white text-xl md:text-2xl uppercase tracking-wide rounded-full shadow-2xl transition-transform hover:scale-105 active:scale-95 py-6 px-8 mb-4" style={{
          background: 'linear-gradient(135deg, #f97316, #ec4899)',
          boxShadow: '0 0 40px rgba(249, 115, 22, 0.5)',
          fontFamily: 'Lato, sans-serif'
        }} data-id="element-192">
            👉 ACCEDÉ AHORA A GESTANDO EN CALMA
          </a>
          <p className="text-gray-400 text-sm" data-id="element-193">
            🔒 Pago 100% seguro · Acceso inmediato · Garantía 7 días
          </p>
        </div>
      </section>

      {/* GUARANTEE SECTION */}
      <section className="w-full bg-white py-14 px-4" data-id="element-194">
        <div className="max-w-xl mx-auto text-center" data-id="element-195">
          <div className="flex justify-center mb-6" data-id="element-196">
            <div className="bg-green-100 rounded-full p-6 shadow-lg" data-id="element-197">
              <ShieldCheckIcon size={56} className="text-green-600" data-id="element-198" />
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-199">
            🔒 Garantía 7 días
          </h2>
          <div className="bg-green-50 border border-green-200 rounded-2xl p-6 shadow-md" data-id="element-200">
            <p className="text-gray-700 text-lg leading-relaxed" data-id="element-201">
              Si no sentís más claridad y seguridad en tu embarazo,{' '}
              <span className="font-black text-green-700" data-id="element-202">
                te devolvemos el 100%.
              </span>
            </p>
            <p className="text-gray-600 mt-3 font-semibold" data-id="element-203">
              Sin explicaciones. Sin riesgo. Sin preguntas.
            </p>
            <div className="flex items-center justify-center gap-2 mt-4" data-id="element-204">
              <LockIcon size={16} className="text-green-600" data-id="element-205" />
              <span className="text-green-700 font-bold text-sm" data-id="element-206">
                Tu inversión está completamente protegida
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS SECTION */}
      <section className="w-full bg-pink-50 py-16 px-4" data-id="element-207">
        <div className="max-w-5xl mx-auto" data-id="element-208">
          <div className="text-center mb-12" data-id="element-209">
            <h2 className="text-3xl md:text-4xl font-black text-gray-900" style={{
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-210">
              Lo que dicen las mamás que ya lo tienen 🌸
            </h2>
            <p className="text-gray-600 mt-3 text-lg" data-id="element-211">
              Madres reales. Resultados reales.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-212">
            {/* Testimonial 1 */}
            <div className="bg-white rounded-2xl p-6 shadow-md border border-pink-100" data-id="element-213">
              <StarRating data-id="element-214" />
              <p className="text-gray-700 mt-4 mb-5 italic leading-relaxed" data-id="element-215">
                "Estaba aterrada con cada síntoma. Gestando en Calma me dio la
                claridad que ningún médico me supo dar. Ahora disfruto mi
                embarazo."
              </p>
              <div className="flex items-center gap-3" data-id="element-216">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-400 to-purple-500 flex items-center justify-center text-white font-black text-sm flex-shrink-0" data-id="element-217">
                  VM
                </div>
                <div data-id="element-218">
                  <p className="font-black text-gray-900 text-sm" data-id="element-219">
                    Valentina M.
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-220">28 años · Córdoba</p>
                </div>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-white rounded-2xl p-6 shadow-md border border-pink-100" data-id="element-221">
              <StarRating data-id="element-222" />
              <p className="text-gray-700 mt-4 mb-5 italic leading-relaxed" data-id="element-223">
                "Lloraba de miedo cada noche. Hoy me siento preparada para el
                parto. Fue la mejor inversión de mi embarazo."
              </p>
              <div className="flex items-center gap-3" data-id="element-224">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-rose-400 to-pink-500 flex items-center justify-center text-white font-black text-sm flex-shrink-0" data-id="element-225">
                  LR
                </div>
                <div data-id="element-226">
                  <p className="font-black text-gray-900 text-sm" data-id="element-227">Luciana R.</p>
                  <p className="text-gray-500 text-xs" data-id="element-228">
                    31 años · Buenos Aires
                  </p>
                </div>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-white rounded-2xl p-6 shadow-md border border-pink-100" data-id="element-229">
              <StarRating data-id="element-230" />
              <p className="text-gray-700 mt-4 mb-5 italic leading-relaxed" data-id="element-231">
                "Pensé que era exagerada. Pero no. Solo necesitaba información
                clara y ordenada. Este sistema me cambió todo."
              </p>
              <div className="flex items-center gap-3" data-id="element-232">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-pink-400 flex items-center justify-center text-white font-black text-sm flex-shrink-0" data-id="element-233">
                  SG
                </div>
                <div data-id="element-234">
                  <p className="font-black text-gray-900 text-sm" data-id="element-235">Sofía G.</p>
                  <p className="text-gray-500 text-xs" data-id="element-236">26 años · Rosario</p>
                </div>
              </div>
            </div>

            {/* Testimonial 4 */}
            <div className="bg-white rounded-2xl p-6 shadow-md border border-pink-100" data-id="element-237">
              <StarRating data-id="element-238" />
              <p className="text-gray-700 mt-4 mb-5 italic leading-relaxed" data-id="element-239">
                "Los bonos solos ya valen todo. Las meditaciones me ayudaron a
                conectar con mi bebé de una manera que no esperaba."
              </p>
              <div className="flex items-center gap-3" data-id="element-240">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-500 to-orange-400 flex items-center justify-center text-white font-black text-sm flex-shrink-0" data-id="element-241">
                  CT
                </div>
                <div data-id="element-242">
                  <p className="font-black text-gray-900 text-sm" data-id="element-243">Camila T.</p>
                  <p className="text-gray-500 text-xs" data-id="element-244">29 años · Mendoza</p>
                </div>
              </div>
            </div>

            {/* Testimonial 5 */}
            <div className="bg-white rounded-2xl p-6 shadow-md border border-pink-100 md:col-span-2 lg:col-span-1" data-id="element-245">
              <StarRating data-id="element-246" />
              <p className="text-gray-700 mt-4 mb-5 italic leading-relaxed" data-id="element-247">
                "Soy médica y aun así me sentía perdida como mamá primeriza.
                Gestando en Calma me dio paz mental real."
              </p>
              <div className="flex items-center gap-3" data-id="element-248">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-indigo-400 to-purple-500 flex items-center justify-center text-white font-black text-sm flex-shrink-0" data-id="element-249">
                  FB
                </div>
                <div data-id="element-250">
                  <p className="font-black text-gray-900 text-sm" data-id="element-251">
                    Florencia B.
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-252">
                    33 años · Mar del Plata
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-10" data-id="element-253">
            <CtaButton href="#comprar" className="bg-gradient-to-r from-pink-500 to-purple-600 text-lg md:text-xl px-8 md:px-12 py-5 shadow-pink-300 shadow-xl" data-id="element-254">
              🌸 QUIERO UNIRME A ELLAS →
            </CtaButton>
          </div>
        </div>
      </section>

      {/* FINAL CTA SECTION */}
      <section className="w-full py-16 px-4" style={{
      background: 'linear-gradient(135deg, #ec4899, #9333ea)'
    }} data-id="element-255">
        <div className="max-w-2xl mx-auto text-center" data-id="element-256">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6 leading-tight" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-257">
            Tu embarazo va a pasar igual.
          </h2>
          <p className="text-xl md:text-2xl text-pink-100 font-bold mb-8 leading-relaxed" data-id="element-258">
            La diferencia es cómo lo vas a vivir.
          </p>
          <div className="bg-white bg-opacity-20 rounded-2xl p-6 mb-10" data-id="element-259">
            <p className="text-white text-xl md:text-2xl font-black leading-relaxed" style={{
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-260">
              Porque no solo está creciendo un bebé.
              <br data-id="element-261" />
              Está creciendo una madre.
              <br data-id="element-262" />
              <span className="text-yellow-300" data-id="element-263">
                Y merece hacerlo con confianza. 🌸✨
              </span>
            </p>
          </div>
          <a href="#comprar" className="inline-block text-center font-black text-white text-xl md:text-2xl uppercase tracking-wide rounded-full shadow-2xl transition-transform hover:scale-105 active:scale-95 py-6 px-10" style={{
          background: 'linear-gradient(135deg, #f97316, #f43f5e)',
          boxShadow: '0 0 50px rgba(249, 115, 22, 0.6)',
          fontFamily: 'Lato, sans-serif'
        }} data-id="element-264">
            👉 ACCEDÉ AHORA A GESTANDO EN CALMA
          </a>
          <p className="text-pink-200 text-sm mt-5" data-id="element-265">
            🔒 Garantía 7 días · Acceso inmediato · Sin riesgo
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="w-full bg-black py-6 px-4 text-center" data-id="element-266">
        <p className="text-gray-500 text-sm" data-id="element-267">
          © 2025 Gestando en Calma · Todos los derechos reservados
        </p>
        <p className="text-gray-600 text-xs mt-1" data-id="element-268">
          Producto digital · Acceso inmediato tras la compra
        </p>
      </footer>
    </div>;
}